import { ARCHETYPES } from "../lib/constants";

const NAMES = { gold: "Gold", blue: "Blue", orange: "Orange", green: "Green" };

/**
 * Display a person's True Colors spectrum as a row of ordered dots.
 * Prefers `user.spectrum` (full array, dominant → lowest). Falls back to
 * `archetype` + `archetype_secondary` so legacy users still render.
 *
 * variant:
 *   - "compact" → just the dots
 *   - "default" → dots + short label like "Gold / Blue / Orange / Green"
 */
export default function ColorCombo({ user, variant = "default", className = "" }) {
  if (!user) return null;
  const spectrum = Array.isArray(user.spectrum) && user.spectrum.length
    ? user.spectrum
    : [user.archetype, user.archetype_secondary].filter(Boolean);
  if (!spectrum.length) return null;

  const colors = spectrum.map((k) => ARCHETYPES[k]).filter(Boolean);
  const label = colors.map((c) => NAMES[c.key]).join(" / ");

  return (
    <span
      data-testid="color-combo"
      className={`inline-flex items-center gap-1.5 ${className}`}
      title={label}
    >
      <span className="inline-flex">
        {colors.map((c, i) => (
          <span
            key={`${c.key}-${i}`}
            data-testid={`color-dot-${c.key}`}
            className="w-2.5 h-2.5 rounded-full border border-white shadow-sm"
            style={{ background: c.color, marginLeft: i === 0 ? 0 : -3 }}
          />
        ))}
      </span>
      {variant === "default" && (
        <span className="text-[10px] uppercase tracking-[0.15em] font-bold text-slate-500">
          {label}
        </span>
      )}
    </span>
  );
}
